import { createContext } from 'react';

const BookingContext = createContext(null);

export default BookingContext;
